export const ADD_PAGE_BY_SHORTCUT = 'REPORTING_ADD_PAGE_BY_SHORTCUT';

export const addPageByShortcut = shortcut => ({
  type: ADD_PAGE_BY_SHORTCUT,
  page: shortcut,
});
